import {AxiosError} from 'axios';
import Logger from '../../logger';
import {APIServiceImpl, ServiceResponse} from '../api';
import {DownloadInviteService} from './download-invite.service';
import {DownloadInviteParams, DownloadInviteResponse} from './download-invite-params';

export class DownloadInviteServiceImpl extends APIServiceImpl implements DownloadInviteService {
  static readonly SEND_DOWNLOAD_INVITE = '/download-invite';

  async sendDownloadInvite(params: DownloadInviteParams): Promise<ServiceResponse<DownloadInviteResponse>> {
    try {
      const {data: res} = await this.post(DownloadInviteServiceImpl.SEND_DOWNLOAD_INVITE, params);
      return new ServiceResponse<DownloadInviteResponse>(res);
    } catch (e: any) {
      const error = this.parseErrorResponse(e);
      Logger.error(`POST ${DownloadInviteServiceImpl.SEND_DOWNLOAD_INVITE} ${JSON.stringify(params)}: ${e.toString()}: ${error}`);
      return new ServiceResponse<DownloadInviteResponse>(undefined, error);
    }
  }

  private parseErrorResponse(error: AxiosError): string {
    if (error.response) {
      const status = error.response.status;
      const data = error.response.data as any;

      if (status === 400) {
        return data?.message || data?.error || 'Invalid phone number. Please check your input and try again.';
      }

      if (status === 429) {
        return data?.message || 'Too many requests. Please wait a moment and try again.';
      }

      if (status === 500) {
        return 'Server error. Please try again later.';
      }

      return data?.message || data?.error || `Request failed with status ${status}`;
    }

    return error.message || 'Network error. Please check your connection and try again.';
  }
}
